<template>
  <div class="footer-bar">
    <div class="footer-inner">
      <span class="footer-copy">
        Copyright © {{ currentYear }} Portailmarchés&nbsp;| Tous Droits Réservés.
      </span>
      <nav class="footer-links">
        <router-link class="footer-link" :to="GENERAL_CONDITION_ROUTE">CGU</router-link>
        <span class="footer-sep">|</span>
        <router-link class="footer-link" :to="LEGAL_ROUTE">Mentions légales</router-link>
        <span class="footer-sep">|</span>
        <router-link class="footer-link" :to="FAQ_ROUTE">FAQ</router-link>
      </nav>
    </div>
  </div>
</template>

<script>
import { FAQ_ROUTE, GENERAL_CONDITION_ROUTE, LEGAL_ROUTE } from '@/router/routes';

export default {
  name: 'FooterView',
  data() {
    return {
      FAQ_ROUTE,
      LEGAL_ROUTE,
      GENERAL_CONDITION_ROUTE,
      currentYear: new Date().getFullYear(),
    };
  }
};
</script>

<style scoped>
.footer-bar {
  background-color: #192937;
  width: 100%;
}

.footer-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 14.71rem;
  gap: 1rem;
}

.footer-copy {
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.75);
  white-space: nowrap;
}

.footer-links {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  flex-shrink: 0;
}

.footer-link {
  font-family: Rubik-Regular, sans-serif;
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.75);
  text-decoration: none;
  padding: 0 0.4rem;
  white-space: nowrap;
  transition: color 0.2s;
}

.footer-link:hover {
  color: #DCC6A5;
  text-decoration: underline;
}

.footer-sep {
  font-size: 0.78rem;
  color: rgba(255, 255, 255, 0.3);
}

/* ── Responsive ── */
@media (max-width: 1400px) {
  .footer-inner { padding: 1rem 5rem; }
}

@media (max-width: 1100px) {
  .footer-inner { padding: 1rem 2rem; }
}

@media (max-width: 680px) {
  .footer-inner {
    flex-direction: column;
    align-items: center;
    padding: 1rem 1.25rem;
    gap: 0.5rem;
    text-align: center;
  }

  .footer-copy {
    white-space: normal;
    text-align: center;
  }
}
</style>
